import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TransitProgramState, TransitProgramMapState } from './transit-program.reducer';

export const transitProgramState = createFeatureSelector<TransitProgramState>('transitProgram');

export const transitProgramMapState = createFeatureSelector<TransitProgramMapState>('transitProgramMap');

export const getTransitMapPrograms = createSelector(transitProgramMapState, (state: TransitProgramMapState) => state.transitPrograms);

export const getTransitPrograms = createSelector(transitProgramState, (state: TransitProgramState) => state.transitPrograms);

export const getOrganizationPaymentMethods = createSelector(
  transitProgramMapState,
  (state: TransitProgramMapState) => state.paymentMethods
);

export const getTransitProgramsPageSize = createSelector(
  transitProgramState,
  (state: TransitProgramState) => state.transitProgramsPageSize
);

export const getTransitProgramsPageIndex = createSelector(
  transitProgramState,
  (state: TransitProgramState) => state.transitProgramsPageIndex
);

export const getShouldShowTransitProgramsLoader = createSelector(
  transitProgramState,
  (state: TransitProgramState) => state.shouldShowTransitProgramsLoader
);

export const getTransitProgram = createSelector(transitProgramState, (state: TransitProgramState) => state.transitProgram);

export const getOrganization = createSelector(transitProgramState, (state: TransitProgramState) => state.organization);

export const getOrganizationServiceLevels = createSelector(
  transitProgramState,
  (state: TransitProgramState) => state.organizationServiceLevels
);

export const getEditing = createSelector(transitProgramState, (state: TransitProgramState) => state.editing);

export const getTransitProgramDrivers = createSelector(transitProgramState, (state: TransitProgramState) => state.transitProgramDrivers);

export const getTransitProgramDriversPageIndex = createSelector(
  transitProgramState,
  (state: TransitProgramState) => state.transitProgramDriversPageIndex
);

export const getTransitProgramDriversPageSize = createSelector(
  transitProgramState,
  (state: TransitProgramState) => state.transitProgramDriversPageSize
);

export const getGeofencesForTransitProgram = createSelector(
  transitProgramState,
  (state: TransitProgramState) => state.transitProgramGeofences
);

export const getGeofenceConditions = createSelector(transitProgramState, (state: TransitProgramState) => state.geofenceConditions);

export const getGeofenceTypes = createSelector(transitProgramState, (state: TransitProgramState) => state.geofenceTypes);

export const getOperatingSchedule = createSelector(transitProgramState, (state: TransitProgramState) => state.operatingSchedule);

export const getFareCalculators = createSelector(transitProgramState, (state: TransitProgramState) => state.fareCalculators);

export const getClientFeeScheduleApprovalStatuses = createSelector(
  transitProgramState,
  (state: TransitProgramState) => state.clientFeeScheduleApprovalStatuses
);
export const getIsLoadingClientFeeSchedules = createSelector(
  transitProgramState,
  (state: TransitProgramState) => state.isLoadingClientFeeSchedules
);

export const getUsersByClientApproverRole = createSelector(
  transitProgramState,
  (state: TransitProgramState) => state.usersByClientApproverRole
);

export const getClientFeeScheduleApprovalObjectInfo = createSelector(
  transitProgramState,
  (state: TransitProgramState) => state.clientFeeScheduleApprovalObjectInfo
);

export const getTransitProgramSubTab = createSelector(transitProgramState, (state: TransitProgramState) => state.transitProgramSubTab);

export const getPaginatedSearchedTransitPrograms = createSelector(
  transitProgramMapState,
  (state: TransitProgramMapState) => state.paginatedTransitProgramsSearchResults
);

export const getPaginatedGetOrganizationPayments = createSelector(
  transitProgramMapState,
  (state: TransitProgramMapState) => state.paymentMethods
);

export const getTransitProgramForTransitProgramMap = createSelector(
  transitProgramMapState,
  (state: TransitProgramMapState) => state.transitProgram
);

export const getTransitProgramGeoFencesForTransitProgramMap = createSelector(
  transitProgramMapState,
  (state: TransitProgramMapState) => state.transitProgramGeofences
);
